import { minLength, maxLength, stringPattern, minItems, stringPatternError } from '../../utils/form-validations';
export const defaultFields = { name: '' };

export const addRoleUISchema = [
  { id: 1, label: 'Role', name: 'name', type: 'input', required: true },
];

export const addRoleSchema = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength,
      maxLength,
    },
  },
  required: ['name'],
  additionalProperties: true,
};
